import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useNeuroState, NeuroMessage } from "@ignitesales/neuro-application";

const getStringId = (buttonText) => {
    switch(buttonText) {
        case 'Apply':
            return 'product.applyBtn';
        case 'Enroll':
            return 'product.enrollBtn';
        case 'Open':
            return 'product.openBtn';
        case 'Contact Us':
            return 'product.contactUsBtn';
        case 'Contact Me':
            return 'product.contactUsBtn';
        case 'Make an Appointment':
            return 'product.makeAppointmentBtn';
        case 'Find a Branch':
            return 'product.findBranchBtn';
        case 'Learn More':
            return 'product.learnMore';
        default:
            return 'product.applyBtn';
    }
};

const ProductActionButton = (props) => {
    const { hideActions } = useNeuroState();
    const classes = classnames('btn btn-primary product-url-btn', props.className);

    return (
        <>
            {
                props.buttonText === 'No Action' || hideActions
                  ? null
                  : props.buttonText === 'Contact Us' || props.buttonText === 'Contact Me' 
                      ? 
                          <a className="btn btn-primary apply-now" href="https://www.renasantbank.com/locations" target="_blank"><NeuroMessage id='summary.visitABranch' /></a>
                        
                      : <a href={props.url} target="_blank" onClick={props.onClick} className={classes}>
                          <NeuroMessage id={getStringId(props.buttonText)}/>
                        </a>
            }
        </>
    );
};

ProductActionButton.propTypes = {
    buttonText: PropTypes.oneOf([
      'Apply',
      'Enroll',
      'Open',
      'No Action',
      'Contact Us',
      'Contact Me',
      'Make an Appointment',
      'Find a Branch',
      null,
      '']),
    url: (props, propName) => {
        if (!!props['buttonText'] && typeof props[propName] !== 'string') {
            return new Error('Please provide a URL for this product');
        }
    },
    onClick: PropTypes.func
};

ProductActionButton.defaultProps = {
  buttonText: 'Apply',
  onClick: () => null
};

export default ProductActionButton;
